/**
 * Promotional code API types shared between API and UI.
 */
// ---------------------------------------------------------------------------
// API client
// ---------------------------------------------------------------------------
export class PromoCodeApi {
    client;
    constructor(client) {
        this.client = client;
    }
    async redeem(params) {
        return this.client.post('/api/account/promo-code/redeem', params);
    }
    async listAdmin(params) {
        const query = new URLSearchParams();
        if (params?.limit != null)
            query.set('limit', String(params.limit));
        if (params?.offset != null)
            query.set('offset', String(params.offset));
        const qs = query.toString();
        return this.client.get(`/api/admin/promo-codes${qs ? `?${qs}` : ''}`);
    }
    async createAdmin(params) {
        return this.client.post('/api/admin/promo-codes', params);
    }
    async updateAdmin(shortcode, params) {
        return this.client.put(`/api/admin/promo-codes/${encodeURIComponent(shortcode)}`, params);
    }
    async deleteAdmin(shortcode) {
        return this.client.delete(`/api/admin/promo-codes/${encodeURIComponent(shortcode)}`);
    }
    async listRedemptionsAdmin(shortcode, params) {
        const query = new URLSearchParams();
        if (params?.limit != null)
            query.set('limit', String(params.limit));
        if (params?.offset != null)
            query.set('offset', String(params.offset));
        const qs = query.toString();
        return this.client.get(`/api/admin/promo-codes/${encodeURIComponent(shortcode)}/redemptions${qs ? `?${qs}` : ''}`);
    }
}
//# sourceMappingURL=promo-code-api.js.map